import * as React from 'react';
import '../../../panels/panels.css';
import { Button, Label, Segment, Form, Input, Radio, Checkbox, Dropdown, Dimmer } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import Toast from '../../../sys/toast';
import OAuth, { OAuthClientStatus } from '../../../api';

class State {
    autoStartMaster: any;
    autoStartVariant: any;
    redirectMode: string;
    redirectType301: boolean;
    redirectType302: boolean;
    redirectType303: boolean;
    redirectType307: boolean;
    redirectType308: boolean;
    redirectTimeout: boolean;
    redirectTransactionLog: string;
    monModeSampleNumSeg: number;
    monModeSampleMediaDl: boolean;
    hostsFile: string;
    contentTypeMissPlMan: any;
    contentTypeMismatchPlMan: any;
    contentTypeMissMedia: any;
    contentTypeMismatchMedia: any;
    contentTypeMissOther: any;
    contentTypeMismatchOther: any;
    dnsServerPrimary: string;
    dnsServerSecondary: string;
    daiTnArchEnable: boolean;
    vodTnArchEnable: boolean;
    rtTnArchEnable: boolean;
    tnArchAvail: boolean;
}

interface Props {

}

export default class MonitoringModeConfig extends React.Component<Props, State> {

    private autoStartMaster: any; private autoStartVariant: any; private redirectMode: any;
    private redirectType301: any; private redirectType302: any; private redirectType303: any;
    private redirectType307: any; private redirectType308: any; private redirectTimeout: any;
    private redirectTransactionLog: any; private monModeSampleNumSeg: number;
    private monModeSampleMediaDl: boolean; private hostsFile: string;
    private contentTypeMissPlMan: any;
    private contentTypeMismatchPlMan: any;
    private contentTypeMissMedia: any;
    private contentTypeMismatchMedia: any;
    private contentTypeMissOther: any;
    private contentTypeMismatchOther: any;
    private dnsServerPrimary: string;
    private dnsServerSecondary: string;
    private daiTnArchEnable: boolean;
    private vodTnArchEnable: boolean;
    private rtTnArchEnable: boolean;
    private tnArchAvail: boolean;

    componentWillMount() {
        this.setState({
            autoStartMaster: '',
            autoStartVariant: '',
            redirectMode: '',
            redirectType301: false,
            redirectType302: false,
            redirectType303: false,
            redirectType307: false,
            redirectType308: false,
            redirectTimeout: false,
            redirectTransactionLog: '',
            monModeSampleMediaDl: false,
            monModeSampleNumSeg: 0,
            hostsFile: '',
            contentTypeMissPlMan: '',
            contentTypeMismatchPlMan: '',
            contentTypeMissMedia: '',
            contentTypeMismatchMedia: '',
            contentTypeMissOther: '',
            contentTypeMismatchOther: '',
            dnsServerPrimary: '',
            dnsServerSecondary: '',
            daiTnArchEnable: false,
            vodTnArchEnable: false,
            rtTnArchEnable: false,
            tnArchAvail: false
        });
        this.fetchData();
    }

    fetchData() {
        let _this = this;
        let url = 'http://default/api/config/section/options/abr';
        axios.post(url, {
            mode: 'get',
            defaults: {
            },
            options: [
                'autoStartMaster',
                'autoStartVariant',
                'redirectMode',
                'redirectType301',
                'redirectType302',
                'redirectType303',
                'redirectType307',
                'redirectType308',
                'redirectTimeout',
                'redirectTransactionLog',
                'monModeSampleMediaDl',
                'monModeSampleNumSeg',
                'hostsFile',
                'contentTypeMissPlMan',
                'contentTypeMismatchPlMan',
                'contentTypeMissMedia',
                'contentTypeMismatchMedia',
                'contentTypeMissOther',
                'contentTypeMismatchOther',
                'dnsServerPrimary',
                'dnsServerSecondary',
                'daiTnArchEnable',
                'vodTnArchEnable',
                'rtTnArchEnable',
                'tnArchAvail'
            ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.section !== undefined) {
                    let responseObject = response.data.section.options;

                    _this.autoStartMaster = responseObject[0].value; _this.autoStartVariant = responseObject[1].value;
                    _this.redirectMode = responseObject[2].value; _this.redirectType301 = responseObject[3].value;
                    _this.redirectType302 =  responseObject[4].value; _this.redirectType303 = responseObject[5].value;
                    _this.redirectType307 = responseObject[6].value; _this.redirectType308 = responseObject[7].value;
                    _this.redirectTimeout =  responseObject[8].value; _this.redirectTransactionLog = responseObject[9].value;
                    _this.monModeSampleMediaDl = responseObject[10].value; _this.monModeSampleNumSeg = responseObject[11].value;
                    _this.hostsFile = responseObject[12].value;
                    _this.contentTypeMissPlMan = responseObject[13].value; _this.contentTypeMismatchPlMan = responseObject[14].value;
                    _this.contentTypeMissMedia = responseObject[15].value; _this.contentTypeMismatchMedia = responseObject[16].value;
                    _this.contentTypeMissOther = responseObject[17].value; _this.contentTypeMismatchOther = responseObject[18].value;
                    _this.dnsServerPrimary = responseObject[19].value; _this.dnsServerSecondary = responseObject[20].value;
                    _this.daiTnArchEnable = responseObject[21].value;
                    _this.vodTnArchEnable = responseObject[22].value; _this.rtTnArchEnable = responseObject[23].value;
                    _this.tnArchAvail = responseObject[24].value;

                    _this.setState({
                        autoStartMaster: _this.autoStartMaster,
                        autoStartVariant: _this.autoStartVariant,
                        redirectMode: _this.redirectMode,
                        redirectType301: _this.redirectType301,
                        redirectType302: _this.redirectType302,
                        redirectType303: _this.redirectType303,
                        redirectType307: _this.redirectType307,
                        redirectType308: _this.redirectType308,
                        redirectTimeout: _this.redirectTimeout,
                        redirectTransactionLog: _this.redirectTransactionLog,
                        monModeSampleNumSeg: _this.monModeSampleNumSeg,
                        monModeSampleMediaDl: _this.monModeSampleMediaDl,
                        hostsFile: _this.hostsFile,
                        contentTypeMissPlMan: _this.contentTypeMissPlMan,
                        contentTypeMismatchPlMan: _this.contentTypeMismatchPlMan,
                        contentTypeMissMedia: _this.contentTypeMissMedia,
                        contentTypeMismatchMedia: _this.contentTypeMismatchMedia,
                        contentTypeMissOther: _this.contentTypeMissOther,
                        contentTypeMismatchOther: _this.contentTypeMismatchOther,
                        dnsServerPrimary: _this.dnsServerPrimary === '255.255.255.255' ? '0.0.0.0' :  _this.dnsServerPrimary,
                        dnsServerSecondary: _this.dnsServerSecondary === '255.255.255.255' ? '0.0.0.0' :  _this.dnsServerSecondary,
                        daiTnArchEnable: _this.daiTnArchEnable,
                        vodTnArchEnable: _this.vodTnArchEnable,
                        rtTnArchEnable: _this.rtTnArchEnable,
                        tnArchAvail: _this.tnArchAvail
                });
                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected array of config values, got ', response.data);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchData() error: ', error);
            });

    }
    updateConfig(e: any, data: any) {
        //    let _this = this;
        let url = 'http://default/api/config/section/options/abr';

        let value = this.state.hostsFile;
        if (this.state.hostsFile === 'disable')
            value = 'disabled';

        axios.post(url, {
            mode: 'modify',
            defaults: {
            },
            options: [{
                'name': 'autoStartMaster',
                'value': this.state.autoStartMaster
            }, {
                'name': 'autoStartVariant',
                'value': this.state.autoStartVariant
            }, {
                'name': 'redirectMode',
                'value': this.state.redirectMode
            }, {
                'name': 'redirectType301',
                'value': this.state.redirectType301
            }, {
                'name': 'redirectType302',
                'value': this.state.redirectType302
            }, {
                'name': 'redirectType303',
                'value': this.state.redirectType303
            }, {
                'name': 'redirectType307',
                'value': this.state.redirectType307
            }, {
                'name': 'redirectType308',
                'value': this.state.redirectType308
            }, {
                'name': 'redirectTimeout',
                'value': this.state.redirectTimeout
            }, {
                'name': 'redirectTransactionLog',
                'value': this.state.redirectTransactionLog
            }, {
                'name': 'monModeSampleNumSeg',
                'value': this.state.monModeSampleNumSeg
            }, {
                'name': 'monModeSampleMediaDl',
                'value': this.state.monModeSampleMediaDl
            }, {
                'name': 'hostsFile',
                'value': value
            }, {
                'name': 'contentTypeMissPlMan',
                'value': this.state.contentTypeMissPlMan
            }, {
                'name': 'contentTypeMismatchPlMan',
                'value': this.state.contentTypeMismatchPlMan
            }, {
                'name': 'contentTypeMissMedia',
                'value': this.state.contentTypeMissMedia
            }, {
                'name': 'contentTypeMismatchMedia',
                'value': this.state.contentTypeMismatchMedia
            }, {
                'name': 'contentTypeMissOther',
                'value': this.state.contentTypeMissOther
            }, {
                'name': 'contentTypeMismatchOther',
                'value': this.state.contentTypeMismatchOther
            }, {
                'name': 'dnsServerPrimary',
                'value': this.state.dnsServerPrimary === '' ? '0.0.0.0' : this.state.dnsServerPrimary
            }, {
                'name': 'dnsServerSecondary',
                'value': this.state.dnsServerSecondary === '' ? '0.0.0.0' : this.state.dnsServerSecondary
            }, {
                'name': 'daiTnArchEnable',
                'value': this.state.daiTnArchEnable
            }, {
                'name': 'vodTnArchEnable',
                'value': this.state.vodTnArchEnable
            }, {
                'name': 'rtTnArchEnable',
                'value': this.state.rtTnArchEnable
            }]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.code === 'SUCCESS') {
                    Toast.info('Monitoring configuration applied');
                } else {
                    Toast.error('failed to update Monitoring configuration');
                }
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('updateConfig() error: ', error);
                Toast.error('failed to update Monitoring configuration');
            });
    }
    render() {
        const hostsFileOptions = [
            { value: 'disabled', text: 'Disabled'},
            { value: 'primary', text: 'Primary/Pre-DNS'},
            { value: 'secondary', text: 'Secondary/Post-DNS'}
        ];
        const contentTypeOptions = [
            { value: 'ignore', text: 'Ignore'},
            { value: 'warn', text: 'Warn'},
            { value: 'fail', text: 'Fail'}
        ];
        return (
            <OAuth.Context>
                {(oauth: OAuthClientStatus) => {
                    return (
                        <React.Fragment>
                            <div className="assetAliasFilters">
                                <Label className="system-config-pageHeader">
                                    Monitoring
                                </Label>
                                <Button
                                    floated="right"
                                    className="rightButton"
                                    content="Apply"
                                    title="Update Config"
                                    onClick={(e, data) => this.updateConfig(e, data)}
                                />
                            </div>
                            <div className="vertical-flex-main">
                            {!oauth.VODOnlyLicensePresent ?
                            <Segment.Group className="system-config-segment">
                                <Segment className="segment-header">Sample Mode</Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                Number of Segments
                                            </Label>
                                            <Input
                                                type="number"
                                                min="1"
                                                max="5"
                                                value={this.state.monModeSampleNumSeg}
                                                onChange={(e: any, data: any) => this.setState({monModeSampleNumSeg: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                Download Media
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.monModeSampleMediaDl}
                                                onChange={(e: any, data: any) => this.setState({monModeSampleMediaDl: data.checked})}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Segment>
                            </Segment.Group>
                            : null}
                            <Segment.Group className="system-config-segment">
                                <Segment className="segment-header">Auto-Start Timing</Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                Time Between Master Open (ms)
                                            </Label>
                                            <Input
                                                maxLength={9}
                                                value={this.state.autoStartMaster}
                                                onChange={(e: any, data: any) => this.setState({autoStartMaster: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                Time Between Variant Open (ms)
                                            </Label>
                                            <Input
                                                maxLength={9}
                                                value={this.state.autoStartVariant}
                                                onChange={(e: any, data: any) => this.setState({autoStartVariant: data.value})}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Segment>
                            </Segment.Group>
                            <Segment.Group className="system-config-segment">
                                <Segment className="segment-header">DNS IP Addresses</Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                Primary DNS Server
                                            </Label>
                                            <Input
                                                data-tip={this.state.dnsServerPrimary}
                                                className="input-width-250"
                                                value={this.state.dnsServerPrimary}
                                                onChange={(e: any, data: any) => this.setState({dnsServerPrimary: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                Secondary DNS Server
                                            </Label>
                                            <Input
                                                data-tip={this.state.dnsServerSecondary}
                                                className="input-width-250"
                                                value={this.state.dnsServerSecondary}
                                                onChange={(e: any, data: any) => this.setState({dnsServerSecondary: data.value})}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Segment>
                            </Segment.Group>
                            <Segment.Group className="system-config-segment">
                                <Segment className="segment-header">Hosts File</Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                Hosts File
                                            </Label>
                                            <Dropdown
                                                search
                                                options={hostsFileOptions}
                                                selection
                                                value={this.state.hostsFile}
                                                onChange={(event: any, data: any) => this.setState({hostsFile: data.value})}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Segment>
                            </Segment.Group>
                                <Segment.Group className="system-config-segment">
                                    <Segment className="segment-header">HTTP Redirect - Mode</Segment>
                                    <Segment>
                                        <Form>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    Standard
                                                </Label>
                                                <Radio
                                                    name="radioGroup"
                                                    value="standard"
                                                    checked={this.state.redirectMode === 'standard'}
                                                    onChange={(e: any, data: any) => this.setState({redirectMode: data.value})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    Permanent
                                                </Label>
                                                <Radio
                                                    name="radioGroup"
                                                    value="permanent"
                                                    checked={this.state.redirectMode === 'permanent'}
                                                    onChange={(e: any, data: any) => this.setState({redirectMode: data.value})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    Temporary
                                                </Label>
                                                <Radio
                                                    name="radioGroup"
                                                    value="temporary"
                                                    checked={this.state.redirectMode === 'temporary'}
                                                    onChange={(e: any, data: any) => this.setState({redirectMode: data.value})}
                                                />
                                            </Form.Group>
                                        </Form>
                                    </Segment>
                                    <Segment className="segment-header">HTTP Redirect - Types</Segment>
                                    <Segment>
                                        <Form>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    301
                                                </Label>
                                                <Checkbox
                                                    className="config-checkbox"
                                                    checked={this.state.redirectType301}
                                                    onChange={(e: any, data: any) => this.setState({redirectType301: data.checked})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    302
                                                </Label>
                                                <Checkbox
                                                    className="config-checkbox"
                                                    checked={this.state.redirectType302}
                                                    onChange={(e: any, data: any) => this.setState({redirectType302: data.checked})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    303
                                                </Label>
                                                <Checkbox
                                                    className="config-checkbox"
                                                    checked={this.state.redirectType303}
                                                    onChange={(e: any, data: any) => this.setState({redirectType303: data.checked})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    307
                                                </Label>
                                                <Checkbox
                                                    className="config-checkbox"
                                                    checked={this.state.redirectType307}
                                                    onChange={(e: any, data: any) => this.setState({redirectType307: data.checked})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    308
                                                </Label>
                                                <Checkbox
                                                    className="config-checkbox"
                                                    checked={this.state.redirectType308}
                                                    onChange={(e: any, data: any) => this.setState({redirectType308: data.checked})}
                                                />
                                            </Form.Group>
                                        </Form>
                                    </Segment>
                                    <Segment>
                                        <Label className="right-align-label">
                                            Timeout (seconds)
                                        </Label>
                                        <Input
                                            maxLength={9}
                                            value={this.state.redirectTimeout}
                                            onChange={(e: any, data: any) => this.setState({redirectTimeout: data.value})}
                                        />
                                    </Segment>
                                    <Segment className="segment-header">HTTP Redirect - Transaction Log</Segment>
                                    <Segment>
                                        <Form>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    None
                                                </Label>
                                                <Radio
                                                    name="radioGroup"
                                                    value="none"
                                                    checked={this.state.redirectTransactionLog === 'none'}
                                                    onChange={(e: any, data: any) => this.setState({redirectTransactionLog: data.value})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    Warning
                                                </Label>
                                                <Radio
                                                    name="radioGroup"
                                                    value="warning"
                                                    checked={this.state.redirectTransactionLog === 'warning'}
                                                    onChange={(e: any, data: any) => this.setState({redirectTransactionLog: data.value})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    Informational
                                                </Label>
                                                <Radio
                                                    name="radioGroup"
                                                    value="informational"
                                                    checked={this.state.redirectTransactionLog === 'informational'}
                                                    onChange={(e: any, data: any) => this.setState({redirectTransactionLog: data.value})}
                                                />
                                            </Form.Group>
                                        </Form>
                                    </Segment>
                                    <Segment className="segment-header">Content Type</Segment>
                                    <Segment>
                                        <Form>
                                            <Form.Group grouped>
                                                <Label className="segment-section-header">
                                                    Playlist/Manifest
                                                </Label>
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    Missing
                                                </Label>
                                                <Dropdown
                                                    search
                                                    options={contentTypeOptions}
                                                    selection
                                                    value={this.state.contentTypeMissPlMan}
                                                    onChange={(event: any, data: any) => this.setState({contentTypeMissPlMan: data.value})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    Mismatch
                                                </Label>
                                                <Dropdown
                                                    search
                                                    options={contentTypeOptions}
                                                    selection
                                                    value={this.state.contentTypeMismatchPlMan}
                                                    onChange={(event: any, data: any) => this.setState({contentTypeMismatchPlMan: data.value})}
                                                />
                                            </Form.Group>
                                        </Form>
                                    </Segment>
                                    <Segment>
                                        <Form>
                                            <Form.Group grouped>
                                                <Label className="segment-section-header">
                                                    Media
                                                </Label>
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    Missing
                                                </Label>
                                                <Dropdown
                                                    search
                                                    options={contentTypeOptions}
                                                    selection
                                                    value={this.state.contentTypeMissMedia}
                                                    onChange={(event: any, data: any) => this.setState({contentTypeMissMedia: data.value})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    Mismatch
                                                </Label>
                                                <Dropdown
                                                    search
                                                    options={contentTypeOptions}
                                                    selection
                                                    value={this.state.contentTypeMismatchMedia}
                                                    onChange={(event: any, data: any) => this.setState({contentTypeMismatchMedia: data.value})}
                                                />
                                            </Form.Group>
                                        </Form>
                                    </Segment>
                                    <Segment>
                                        <Form>
                                            <Form.Group grouped>
                                                <Label className="segment-section-header">
                                                    Other
                                                </Label>
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    Missing
                                                </Label>
                                                <Dropdown
                                                    search
                                                    options={contentTypeOptions}
                                                    selection
                                                    value={this.state.contentTypeMissOther}
                                                    onChange={(event: any, data: any) => this.setState({contentTypeMissOther: data.value})}
                                                />
                                            </Form.Group>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    Mismatch
                                                </Label>
                                                <Dropdown
                                                    search
                                                    options={contentTypeOptions}
                                                    selection
                                                    value={this.state.contentTypeMismatchOther}
                                                    onChange={(event: any, data: any) => this.setState({contentTypeMismatchOther: data.value})}
                                                />
                                            </Form.Group>
                                        </Form>
                                    </Segment>
                            </Segment.Group>
                            {oauth.QoELicensePresent && !oauth.VODOnlyLicensePresent ?
                            <OAuth.Feature DAI>
                                <Segment.Group className="system-config-segment dimmer-light">
                                    <Dimmer active={!this.state.tnArchAvail}>
                                        <h6>A thumbnail archive must be created before enabling. Contact Telestream Technical Support for assistance in this process.</h6>
                                    </Dimmer>
                                    <Segment className="segment-header">DAI Thumbnail Storage</Segment>
                                    <Segment>
                                        <Form>
                                            <Form.Group grouped>
                                                <Label className="right-align-label">
                                                    Enable for dynamic advertisements
                                                </Label>
                                                <Checkbox
                                                    className="config-checkbox"
                                                    checked={this.state.daiTnArchEnable}
                                                    onChange={(e: any, data: any) => this.setState({daiTnArchEnable: data.checked})}
                                                />
                                            </Form.Group>
                                        </Form>
                                    </Segment>
                                </Segment.Group>
                            </OAuth.Feature>
                            : null}
                            {oauth.QoELicensePresent && (oauth.VODLicensePresent || oauth.VODOnlyLicensePresent) ?
                            <Segment.Group className="system-config-segment dimmer-light">
                                <Dimmer active={!this.state.tnArchAvail}>
                                    <h6>A thumbnail archive must be created before enabling. Contact Telestream Technical Support for assistance in this process.</h6>
                                </Dimmer>
                                <Segment className="segment-header">VOD Thumbnail Storage</Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                Enable for video on demand
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.vodTnArchEnable}
                                                onChange={(e: any, data: any) => this.setState({vodTnArchEnable: data.checked})}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Segment>
                            </Segment.Group>
                            : null}
                            {oauth.QoELicensePresent && !oauth.VODOnlyLicensePresent ?
                            <Segment.Group className="system-config-segment dimmer-light">
                                <Dimmer active={!this.state.tnArchAvail}>
                                    <h6>A thumbnail archive must be created before enabling. Contact Telestream Technical Support for assistance in this process.</h6>
                                </Dimmer>
                                <Segment className="segment-header">Real Time Thumbnail Storage</Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="right-align-label">
                                                Enable for real time
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.rtTnArchEnable}
                                                onChange={(e: any, data: any) => this.setState({rtTnArchEnable: data.checked})}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Segment>
                            </Segment.Group>
                            : null}
                            </div>
                        </React.Fragment>
                    );
                }}
            </OAuth.Context>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/monitoring/monitoringModeConfig.tsx